<script lang="ts">
import ModalBase from './Base.vue'

export default {
    name: 'ModalMiddle',
    extends: ModalBase,
    emits: ['save', 'closeModal', 'deleteData'],
}
</script>

<template>
    <div>
        <v-dialog
            :persistent
            v-model="drawer" :max-width="maxWidth" scrollable
            @update:model-value="closeModal(true)"
        >
            <v-card>
                <!-- HEADER -->
                <v-card-title class="d-flex pt-4 pl-6 border-b">
                    <h2 class="text-h5">
                        <!-- TITLE -->
                        <span v-if="titleModal" class="mr-3" v-html="titleModal" />
                        <!-- CUSTOM TOP BUTTONS -->
                        <template v-if="currentKey && !isForm && permissionName && !hideTopButtons">
                            <ModalTopButtons
                                :is-form="isForm" :permission-name="permissionName" :translation-name="translationName" :delete-disabled="deleteDisabled" :edit-disabled="editDisabled" :data="data"
                                @redirect-edit="redirectEdit" @delete-data="$emit('deleteData', $event)" @redirect-table="redirectTable"
                            >
                                <template #customButtons>
                                    <slot
                                        name="customButtons"
                                        :item="data"
                                    />
                                </template>
                            </ModalTopButtons>
                        </template>
                    </h2>
                    <v-spacer />
                    <!-- CLOSE BUTTON -->
                    <v-btn icon variant="text" size="small" aria-label="Fermer" @click.prevent="closeModal()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text ref="content">
                    <!-- CUSTOM TOP BUTTONS -->
                    <slot name="customContentTop" />
                    <!-- CONTENT -->
                    <slot name="content" />
                </v-card-text>
                <!-- ACTIONS -->
                <v-card-actions v-if="!hideDefaultActions" class="border-t pa-4">
                    <ModalBottomButtons
                        :permission-name
                        :is-form="isForm"
                        :saving="saving"
                        :edit-disabled="editDisabled"
                        :delete-disabled="deleteDisabled"
                        :save-text="saveText"
                        :custom-button-color="customButtonColor"
                        :custom-button-block="customButtonBlock"
                        :disable-save-button="disableSaveButton"
                        :current-key="currentKey"
                        @close-modal="closeModal"
                        @save="$emit('save');"
                        @redirect-edit="redirectEdit"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <template v-if="showCloseMessage">
            <ModalPreventClose @close-modal="closeModal" />
        </template>
    </div>
</template>
